// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
    RELEASE_STAGE: 'development',
    production: false,
    test: true,
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    VERSION: require('../../package.json').version,
    FILE_UPLOAD_MAX_SIZE: 52428800,
    AUTHPASS: btoa('test:test'),
    ERROR_URL: '',
    ERROR_NOTIFY_ACTIVE: false,
    INTERCOM: {
        KEY: 'iti32tfi',
        API_BASE: 'https://api-iam.eu.intercom.io',
    },
    TAWK_KEY: '5f1036085b59f94722bad797',
    termalPrinter: {
        port: '7777',
    },
    service: {
        v1: {
            protocol: 'http://',
            rootUrl: 'localhost',
            apiPort: ':9090',
            apiUrl: '/booking/erp/api',
        },
        v2: {
            protocol: 'http://',
            rootUrl: 'localhost',
            apiPort: ':9190',
            apiUrl: '/booking/eav2/erp/api',
        },
    },
    auth: {
        protocol: 'http://',
        rootUrl: 'localhost',
        port: ':8080',
        url: '/booking/oauth/token',
    },
    report: {
        protocol: 'http://',
        rootUrl: 'localhost',
        port: ':9095',
        url: '/booking/erp/report1',
    },
    document: {
        protocol: 'http://',
        rootUrl: 'localhost',
        port: ':9090',
        url: '/booking/erp/docapi',
    },
    printserver: {
        protocol: 'http://',
        rootUrl: 'localhost',
        port: ':9190',
        url: '/booking/eav2/erp/papi',
    },
    task: {
        protocol: 'http://',
        rootUrl: 'localhost',
        port: ':9190',
        url: '/booking/eav2/erp/taskapi',
    },
    crpp: {
        protocol: 'http://',
        rootUrl: 'localhost',
        port: ':9190',
        url: '/booking/eav2/crpp/api',
    },
    accounting: {
        v1: {
            protocol: 'http://',
            rootUrl: 'localhost',
            port: ':9090',
            url: '/booking/erp/aapi',
        },
        v2: {
            protocol: 'http://',
            rootUrl: 'localhost',
            port: ':9190',
            url: '/booking/eav2/erp/aapi',
        },
    },
    visit: {
        v1: {
            protocol: 'http://',
            rootUrl: 'localhost',
            port: ':9090',
            url: '/booking/erp/visitapi',
        },
        v2: {
            protocol: 'http://',
            rootUrl: 'localhost',
            port: ':9190',
            url: '/booking/eav2/erp/visitapi',
        },
    },
    communication: {
        protocol: 'http://',
        rootUrl: 'localhost',
        port: ':9190',
        url: '/booking/eav2/erp/communicationapi',
    },
    statistics: {
        protocol: 'http://',
        rootUrl: 'localhost',
        port: ':9190',
        url: '/booking/eav2/erp/statsapi',
    },
    surveys: {
        protocol: 'http://',
        rootUrl: 'localhost',
        port: ':9190',
        url: '/booking/eav2/surveys',
    },
    access: {
        protocol: 'http://',
        rootUrl: 'localhost',
        port: ':9190',
        url: '/booking/eav2/access',
    },
    assistance: {
        v1: {
            protocol: 'http://',
            rootUrl: 'localhost',
            port: ':9090',
            url: '/booking/assistance/api',
        },
        v2: {
            protocol: 'http://',
            rootUrl: 'localhost',
            port: ':8092',
            url: '/booking/v2/assistance/api',
        },
        v3: {
            protocol: 'http://',
            rootUrl: 'localhost',
            port: ':5550',
            url: '/booking/asv2/assistance',
        },
    },
    triage: {
        protocol: 'http://',
        rootUrl: 'localhost',
        port: ':9090',
        url: '/booking/erp/triageapi',
    },
    treatment: {
        v1: {
            protocol: 'http://',
            rootUrl: 'localhost',
            port: ':9090',
            url: '/booking/erp/treatments',
        },
        v3: {
            protocol: 'http://',
            rootUrl: 'localhost',
            port: ':9190',
            url: '/booking/eav2/erp/treatments',
        },
    },
    telemed: {
        protocol: 'http://',
        rootUrl: 'localhost',
        port: ':9090',
        url: '/booking/erp/telemed',
    },
    onesignal: {
        appId: 'ceaf68a9-01d3-4177-baa1-298e2f81f5a5',
        allowLocalhostAsSecureOrigin: true,
        defaultUrl: 'https://localhost:4200',
        defaultTitle: 'eAmbulanta | DEV',
        safariWebId: 'web.onesignal.auto.548f76b5-1495-4e31-bc8e-b1b76d8ec8fd',
    },
    root: {
        v1: {
            protocol: 'http://',
            rootUrl: 'localhost',
            port: ':8080',
            url: '/booking',
        },
        v3: {
            protocol: 'http://',
            rootUrl: 'localhost',
            port: ':9190',
            url: '/booking',
        },
    },
    agora: {
        appId: 'cc7bce7c08c44569b7f8a88ecf3dfd24',
        logLevel: 0,
    },
    itero: {
        protocol: 'http://',
        rootUrl: 'localhost',
        port: ':9090',
        url: '/booking/erp/itero',
    },
    webSocket: {
        protocol: 'ws://',
        rootUrl: 'localhost',
        port: ':8888',
        url: '/booking/ws/ea',
    },
    webSocketTelemed: {
        protocol: 'ws://',
        rootUrl: 'localhost',
        port: ':8888',
        url: '/booking/ws/telemed/',
    },
    toolsUrl: {
        protocol: 'https://',
        rootUrl: 'test-link.eambulanta.si/tools',
        port: '',
        url: '',
    },

    widget: {
        protocol: 'http://',
        rootUrl: 'localhost',
        port: ':9090',
        url: '/booking/eav2/widgetapi',
    },
    wizard: {
        protocol: 'http://',
        rootUrl: 'localhost',
        port: ':9190',
        url: '/booking/eav2/wizardapi',
    },
    oim: {
        protocol: 'http://',
        rootUrl: 'localhost',
        port: ':9190',
        url: '/booking/eav2/oim/api',
    },
    widgetUrl: 'https://test-booking.eambulanta.si/widget/widget.min.js',
    webSocketHelloDoc: {
        reconnectInterval: 2000,
        protocol: 'ws://',
        rootUrl: 'localhost',
        port: ':8888',
        url: '/booking/ws/hellodoctor',
    },
    aircall: {
        protocol: 'http://',
        rootUrl: 'localhost',
        port: ':9190',
        url: '/booking/eav2/erp/aircallapi',
    },

    erpRootUrl: {
        protocol: 'http://',
        rootUrl: 'localhost',
        port: ':9190',
        url: '/booking/eav2/erp',
    },
    eav2RootUrl: {
        protocol: 'http://',
        rootUrl: 'localhost',
        port: ':9190',
        url: '/booking/eav2',
    },

    unsupportedServices: [
        {
            id: '804c5d6f-a874-41d9-95f9-20ac1f80f3bb',
            name: 'Paradontološki pregled s čiščenjem zobnega kamna',
            steps: [1, 2],
        },
        {
            id: 'e256d569-da69-41a7-b53c-8321a1ba6957',
            name: 'Neurofeedback - merjenje možganskega valovanja',
            steps: [1, 2],
        },
        {
            id: '77165866-92fb-459b-bca5-651743b4d818',
            name: 'Mamografija',
            steps: [1, 2],
        },
        {
            id: 'f3f8b161-44e0-4bdf-a63d-ad51e428659d',
            name: 'Laboratorijski pregled krvi in urina z izvidom',
            steps: [1, 2, 4, 5, 6, 7],
        },
        {
            id: '80f0f2a7-2cc0-4d26-9e4d-1aab1df6213a',
            name: 'PSA test',
            steps: [1, 2, 4, 5, 6, 7],
        },
        {
            id: '7b4c2416-9f2c-4054-be14-cd761133b7db',
            name: 'Helikobakter - prisotnost želodčne bakterije',
            steps: [1, 2, 4, 5, 6, 7],
        },
        {
            id: 'b9f93a7d-edf9-45e3-9a69-9be31baba6f3',
            name: 'Odvzem blata za ugotavljanje prikrite krvavitve v blatu',
            steps: [1, 2, 4, 5, 6, 7],
        },
        {
            id: '7d4f66c7-fc72-44e8-8403-ed22cd05b362',
            name: 'Pregled za športno aktivne osebe',
            steps: [1, 2, 4, 5, 6, 7],
        },
        {
            id: 'c4fcad3d-77cc-4c29-b63a-6d2073a67bfd',
            name: 'Fotopletizmografska preiskava ven (oba uda)',
            steps: [1, 2],
        },
        {
            id: '9d83e6a8-6a5d-4df9-accf-d73dbf9711e9',
            name: 'Pregled stopal in meritve hoje',
            steps: [1, 2],
        },
    ],

    G100FollowupServiceId: 553,
};
